// extracted by mini-css-extract-plugin
module.exports = {"root":"selection_root__1ayL_","address":"selection_address__cMKJL","input":"selection_input__tC5e8","container":"selection_container__2Rb4D","disabled":"selection_disabled__8Z9tk"};